import type { LeadSubmitPayload } from '#shared/types/lead'

import { useLeadNotice } from '~/composables/useLeadNotice'

export const useLeadSubmit = () => {
  const roistatVisitCookie = useCookie<string | null>('roistat_visit')
  const { getTrackingPayload } = useLeadTracking()
  const leadNotice = useLeadNotice()

  const submitLead = async (payload: LeadSubmitPayload): Promise<void> => {
    const roistatVisitValue = roistatVisitCookie.value
    const roistatVisit =
      typeof roistatVisitValue === 'string' ? roistatVisitValue.trim() : undefined

    // «Заявка принята» — только после ответа сервера; при ошибке — сообщение с телефоном.
    // Ошибка пробрасывается дальше: формы по-прежнему её логируют.
    try {
      await $fetch('/api/leads', {
        method: 'POST',
        body: {
          ...getTrackingPayload(),
          ...payload,
          ...(roistatVisit ? { roistatVisit } : {}),
        },
      })
      leadNotice.show('success')
    } catch (error: unknown) {
      leadNotice.show('error')
      throw error
    }
  }

  return {
    submitLead,
  }
}
